// extracted by mini-css-extract-plugin
export const container = "cartSidebar-module--container--3N1Rt";
export const shadow = "cartSidebar-module--shadow--12C0J";
export const shadowExit = "cartSidebar-module--shadow-exit--2n4-W";
export const isOpen = "cartSidebar-module--isOpen--35UZr";
export const shadowEnter = "cartSidebar-module--shadow-enter--1joBU";
export const cartHeader = "cartSidebar-module--cartHeader--1d5Ya";
export const close = "cartSidebar-module--close--mS4aJ";
export const cartMain = "cartSidebar-module--cartMain--2i-uk";
export const menu = "cartSidebar-module--menu--1Dujg";